import { render, staticRenderFns } from "./UserOddsDrawer.vue?vue&type=template&id=271039a5&scoped=true"
import script from "./UserOddsDrawer.vue?vue&type=script&lang=js"
export * from "./UserOddsDrawer.vue?vue&type=script&lang=js"
import style0 from "./UserOddsDrawer.vue?vue&type=style&index=0&id=271039a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271039a5",
  null
  
)

export default component.exports